import { useMonocle } from "./client-boundary/hooks";
import { MonocleProvider } from "./client-boundary/MonocleProvider";
export {
  MonocleProvider,
  useMonocle
};
//# sourceMappingURL=index.js.map